<template>
  <div id="app">
    <BacNumber @showInterstitialChange="changeShowInterstitial" @firstNameUpdate="firstNameUpdate" @lastNameUpdate="lastNameUpdate" @emailUpdate="emailUpdate" @zipUpdate="zipUpdate" @bgChargeUpdate="bgChargeUpdate" @addressUpdate="addressUpdate" @cityUpdate="cityUpdate" @stateUpdate="stateUpdate" @companyUpdate="companyUpdate" @update="onPanelOneUpdate"/>
    <PaymentInterstitial @hideLoading="hideLoading" ref="paymentModal" v-bind:firstName="this.firstName" v-bind:lastName="this.lastName" v-bind:company="this.company" v-bind:companyFein="this.companyFein" v-bind:address="this.address" v-bind:city="this.city" v-bind:state="this.state" v-bind:zipcode="this.zipcode" v-bind:backgroundCharge="this.paymentDue" v-bind:email="this.email" @changeInterstitialComplete="changeInterstitialComplete" @testStatusInter="testStatusInter" />
    <fade-loader :loading="loading" ></fade-loader>
  </div>
</template>

<script>
import BacNumber from './components/BacNumber.vue'
import PaymentInterstitial from './components/PaymentInterstitial.vue'
import FadeLoader from './components/FadeLoader.vue'
import JQuery from 'jquery'

window.$ = JQuery;

export default {
  name: 'App',
  components: {
    BacNumber,
    PaymentInterstitial,
    FadeLoader
  },
  data: function() {
    return {      
      "loading": false,
      "paymentDue": 0.00,
      "firstName": "",
      "lastName": "",
      "company": "",
      "companyFein": "",
      "address": "",
      "city": "",
      "state": "",
      "email": "",
      "zipcode": "",
      "ssn": "",
      "phone":"",
      "showInterstitial": false,
      "interstitialComplete": false
    }
  },
  methods: {
    firstNameUpdate(data){
        this.firstName = data;
    },
    lastNameUpdate(data){
        this.lastName = data;
    },
    emailUpdate(data){
        this.email = data;
    },
    addressUpdate(data){
        this.address = data;
    },
    cityUpdate(data){
        this.city = data;
    },
    stateUpdate(data){
        this.state = data;
    },
    zipUpdate(data){
        this.zipcode = data;
    },
    companyUpdate(data){
        this.company = data;
    },
    companyFeinUpdate(data){
        this.companyFein = data;
    },
    bgChargeUpdate(data){
        this.paymentDue = data;
    },
    changeCandidateUrl (newValue) {
      window.location.replace(newValue);
    },
    changeShowInterstitial(newInterstitialValue) {
      this.showInterstitial = newInterstitialValue;
      if(this.showInterstitial == true) {
        this.$refs.paymentModal.showModal();
        this.hideLoading()
      }
    },
    changeInterstitialComplete (newValue) {
      this.interstitialComplete = newValue;
    },
    formComplete() {
      this.changeShowInterstitial(false);
      this.$refs.paymentModal.hideModal();
      this.hideLoading()
      window.$("#app").children().hide();
      window.$("#app").append("<span>Thank you for your payment to AREMCO.  One of our representatives will be reaching out to you within 72 hours.</span>");
    },
    hideLoading() {
      this.loading = false;
    },
    onPanelOneUpdate (newValue) {
      this.loading = newValue;
    },
    showLoading() {
      this.loading = true;
    },
    testStatus() {
      if(this.showInterstitial == false) {
        this.formComplete();
      } else if(this.showInterstitial == true && this.interstitialComplete == true) {
        this.formComplete();
      }
    },
    testStatusInter() {
        this.formComplete();
    }
  }
}
</script>

<style>
</style>
